//
//
//
//
//
//
//
//

import videojs from 'video.js';

export default {

    name: 'VideoPlayer',

    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        secureOptions: {
          type: Object,
          default() {
            return {};
          }
        },
        isSecure: {
          type: Boolean,
          default: false
        },
    },

    data() {
        return {
            player: null,
            keyPrefix: 'key://',
        }
    },

    mounted() {
      this.player = videojs(this.$refs.videoPlayer, this.options, this.onPlayerReady)
      if(this.isSecure) {
        this.setSourceSecure()
      }
    },

    beforeDestroy() {

        if (this.player) {
            this.player.dispose()
        }

    },

    methods: {

      onPlayerReady() {

        this.$emit('player-ready')

        if(this.isSecure) {
          this.onPlayerReadySecure()
        }

      },

      onPlayerReadySecure() {

        this.player.on('loadstart', (e) => {

          this.player.tech(true).vhs.xhr.beforeRequest = (options) => {

            if (!options.uri.startsWith(this.keyPrefix)) { return options }

            options.headers = options.headers || {}
            options.headers["Evintra-Token"] = this.secureOptions.token

            options.uri = options.uri.replace(this.keyPrefix, 'https://')
            return options

          }

        })

      },

      setSourceSecure() {

        this.player.src({
          src: 'https://'+this.secureOptions.cdnDomain+'/private/'+this.secureOptions.video,
          type: 'application/x-mpegURL',
          withCredentials: true,
          cacheEncryptionKeys: true,
        })

      },

      getPlayers() {
        return videojs.getPlayers()
      },

      getPlayer(id) {
        return videojs.getPlayer(id)
      }

    },
}
